import { render, staticRenderFns } from "./case-studies.vue?vue&type=template&id=1ccbd10c&scoped=true&"
import script from "./case-studies.vue?vue&type=script&lang=js&"
export * from "./case-studies.vue?vue&type=script&lang=js&"
import style0 from "./case-studies.vue?vue&type=style&index=0&id=1ccbd10c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccbd10c",
  null
  
)

export default component.exports